<script>
  export let label;
  export let checked;
</script>

<div class="checkbox-container">
  <label>
    <input type="checkbox" bind:checked />
    {label}
  </label>
</div>

<style>
  .checkbox-container {
    padding-left: 100px;
    vertical-align: middle;
  }
  .checkbox-container input {
    vertical-align: middle;
    position: relative;
    bottom: -1px;
  }

  .checkbox-container label {
    display: block;
  }
</style>
